import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteVenue($companyId: ID!, $id: ID!) {
    deleteVenue(companyId: $companyId, id: $id) {
      venue {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
